'use client';

import type { HTMLAttributes } from 'react';

import Link from 'next/link';

import { cn } from '@/libs';
import { ROUTES } from '@/types/enums';

import { Icon } from '../ui';

import type { z } from 'zod';

type TitlePageProps = HTMLAttributes<HTMLDivElement> & {
  title: string;
  href?: z.infer<typeof ROUTES>;
};

export const TitlePage = ({ title, href, className, ...props }: TitlePageProps) => {
  return (
    <>
      {!href && (
        <h1
          className={cn('text-lg md:text-2xl lg:text-3xl	 font-bold', className)}
          {...props}
        >
          {title}
        </h1>
      )}
      {href && (
        <Link href={href || ROUTES.enum['/']}>
          <div className="flex flex-row items-center gap-2 mb-4">
            <Icon.ChevronLeft
              width={24}
              height={24}
              className="cursor-pointer text-foreground bg-background-dark rounded-full p-1"
            />
            <h1
              className={cn('text-lg md:text-2xl lg:text-3xl	 font-bold', className)}
              {...props}
            >
              {title}
            </h1>
          </div>
        </Link>
      )}
    </>
  );
};
